import { createGlobalStyle } from 'styled-components';

export const CookieScriptGlobalStyles = createGlobalStyle`
  #cookiescript_badge, #cookiescript_injected {
    display: none;
    visibility: hidden;
  }
`;

export const CookieScriptBadgeHiddenStyles = createGlobalStyle`
  #cookiescript_badge {
    display: none !important;
  }
`;
